import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  RefObject,
  useRef,
} from 'react';

import { tracks as _tracks } from '../data/tracks';

// export interface Track {
//   title: string;
//   src: string;
//   author: string;
//   thumbnail?: string;
// }

// interface AudioPlayerContextType {
//   currentTrack: Track;
//   setCurrentTrack: Dispatch<SetStateAction<Track>>;
//   timeProgress: number;
//   setTimeProgress: Dispatch<SetStateAction<number>>;
//   duration: number;
//   setDuration: Dispatch<SetStateAction<number>>;
//   setTrackIndex: Dispatch<SetStateAction<number>>;
//   audioRef: RefObject<HTMLAudioElement>;
//   progressBarRef: RefObject<HTMLInputElement>;
//   isPlaying: boolean;
//   setIsPlaying: Dispatch<SetStateAction<boolean>>;
// }

const AudioPlayerContext = createContext(undefined);

export const AudioPlayerProvider = ({
  children,
}) => {
  const [tracks, setTracks] = useState(_tracks);
  const [trackIndex, setTrackIndex] = useState(0);

  const [currentTrack, setCurrentTrack] = useState(
    tracks[trackIndex]
  );
  const [timeProgress, setTimeProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const audioRef = useRef(null);
  const progressBarRef = useRef(null);

  const contextValue = {
    tracks, 
    setTracks,
    currentTrack,
    setCurrentTrack,
    audioRef,
    progressBarRef,
    timeProgress,
    setTimeProgress,
    duration,
    setDuration,
    setTrackIndex,
    isPlaying,
    setIsPlaying,
  };

  return (
    <AudioPlayerContext.Provider value={contextValue}>
      {children}
    </AudioPlayerContext.Provider>
  );
};

// export const AudioPlayerConsumer = ({
//   children,
// }) => {
//   return (
//     <AudioPlayerContext.Consumer>
//        {({ 
//         tracks, 
//         setTracks,
//         currentTrack,
//         setCurrentTrack,
//         audioRef,
//         progressBarRef,
//         timeProgress,
//         setTimeProgress,
//         duration,
//         setDuration,
//         setTrackIndex,
//         isPlaying,
//         setIsPlaying
//        }) => (<React.Fragment>{children}</React.Fragment>)}
//     </AudioPlayerContext.Consumer>
//   );
// };

export const useAudioPlayerContext = () => {
  const context = useContext(AudioPlayerContext);

  if (context === undefined) {
    throw new Error(
      'useAudioPlayerContext must be used within an AudioPlayerProvider'
    );
  }

  return context;
};
